export const isActive = (router, categorySlug) => {
  if (!router?.query?.cat) return false

  return router?.query?.cat[0] === categorySlug
}

export const isAllCategoryPage = (router) => !router?.query?.cat?.length
